import { configureStore } from "@reduxjs/toolkit";

import thunk from "redux-thunk";
import authReducer from "./Reducer/AuthReducer";
import themeReducer from "./Reducer/ThemeReducer";
import mtableReducer from "./Reducer/MTableReducer";
import AppReducer from "./Reducer/AppReducer";
import PaginateReducer from "./Reducer/PaginateReducer";

const store = configureStore({
  reducer: {
    app: AppReducer,
    auth: authReducer,
    theme: themeReducer,
    mtable: mtableReducer,
    paginate: PaginateReducer,
  },
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware().concat(thunk)],
});

export default store;
